import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import { QueryParamsEntities2 } from "./MainApp";
import { PaginationV2 } from "./Pagination";

export class KulionerProduct {
  kodId = 0;
  kodProductName = "";
  kodProductThumbnail = "";
  kodQuantity = 0;
  kodPrice = 0;
  kodTotalPrice = 0;

  constructor(fields?: Partial<KulionerProduct>) {
    Object.assign(this, fields);
  }
}

export class KulionerHistory {
  kohId = 0;
  kohStatus = "";
  kohCreatedAt = "";
  kohCreatedBy = "";

  constructor(fields?: Partial<KulionerHistory>) {
    Object.assign(this, fields);
  }
}

export class KulionerOrder {
  koId = 0;
  koStatus = "";
  koOrderId = "";
  koOrderShipmentId = "";
  koOrderSttNo = "";
  koIsMarkProcessed = false;
  koCreatedAt = "";
  koUpdatedAt = "";
  koTotalProduct = 0;
  koTotalQuantity = 0;
  koMerchantName = "";
  koMerchantPhoneNumber = "";
  koMerchantAddress = "";
  koMerchantLatlon = "";
  koRecipientName = "";
  koRecipientPhoneNumber = "";
  koRecipientAddress = "";
  koTotalPrice = 0;
  koProductType = "";
  koProduct: KulionerProduct[] = [];
  koHistories: KulionerHistory[] = [];

  constructor(fields?: Partial<KulionerOrder>) {
    Object.assign(this, fields);
  }
}

export class Kulioner {
  order: KulionerOrder[] = [];
  summary: Record<string, number> = {};

  constructor(fields?: Partial<Kulioner>) {
    Object.assign(this, fields);
  }
}

export class KulionerEntites {
  pagination = new PaginationV2();
  data = new Kulioner();

  constructor(fields?: Partial<KulionerEntites>) {
    Object.assign(this, fields);
  }
}

export class DownloadReportRequest {
  startDate = "";
  endDate = "";
  constructor(fields?: Partial<DownloadReportRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities2(ConvertObjectCamelToSnakeCase(this))
      .queryString;
  }
}

export class KulionerConfirmOrderEntites {
  id = [];

  constructor(fields?: Partial<KulionerConfirmOrderEntites>) {
    Object.assign(this, fields);
  }
}

